export function humanizeDuration(duration: number): string {
  const minutes = duration % 60;
  const hours = Math.floor(duration / 60);
  if (hours < 1) {
    return `${minutes}min`;
  }
  return `${hours}h${minutes}`;
}
